"use client";
import * as images from "@/components/images/Images_second";
import { Content } from "@/lib/getDocumentsAndDeliverables";
import { Typography } from "@/components/ui/typography";
import { CasesCardCarousel } from "@/components/screen/global-components/cases";
import { CasesCardProps } from "@/components/screen/global-components/cases/CasesCard";

type Props = {
  content: Content;
};

export default function DocumentUseCaseBlock({ content }: Props) {
  const { useCaseTitle, useCaseDescription } = content;

  const items: CasesCardProps[] = [
    {
      title: "Academic",
      description:
        "Translate academic transcripts, diplomas, and records with certified accuracy for university admissions and international education requirements.",
      linkLabel: "Review",
      link: "/use-cases/academic",
      imageUrl: images.academic,
    },
    {
      title: "Immigration (USCIS)",
      description:
        "Expert translation, certification, and notarization services for personal documents, meeting strict requirements for USCIS and immigration acceptance.",
      linkLabel: "Review",
      link: "/use-cases/uscis-immigration",
      imageUrl: images.useCaseTest2,
    },
    {
      title: "Legal",
      description:
        "Precise and secure certified translations for legal documents ensuring accuracy, and compliance in global legal proceedings.",
      linkLabel: "Review",
      link: "/use-cases/legal",
      imageUrl: images.useCaseTest1,
    },
    {
      title: "Marketing",
      description:
        "Localize marketing content that resonates across global markets, while preserving brand voice and cultural nuance.",
      linkLabel: "Review",
      link: "/use-cases/marketing",
      imageUrl: images.marketing_small,
    },
  ];

  return (
    <section className="section overflow-hidden bg-background-secondary md:bg-white">
      <div className="container mx-auto py-12 lg:py-20">
        <div className="flex flex-col gap-4 md:justify-center md:gap-2 md:w-full md:max-w-[900px] md:mx-auto md:text-center">
          <Typography variant="heading4">
            <h2>{useCaseTitle}</h2>
          </Typography>
          <div className="flex justify-center text-gray-600">
            <Typography variant="subHeadingSm" asChild>
              <p>{useCaseDescription}</p>
            </Typography>
          </div>
        </div>
        <CasesCardCarousel cards={items} className="mt-6 lg:!mt-12" />
      </div>
    </section>
  );
}
